<div>
    <h2 class="head2">{{ currentStageSchema.label }}</h2>
    <div class="spacer-sm"></div>
    <span class="normal"> {{ currentStageSchema.description }}</span>
    <div class="spacer"></div>
</div>
<div *ngFor="let stageSchema of this.getReviewableStageSchemas()">
    <dr-review-stage
        [reviewMode]="true"
        [adminMode]="adminView"
        [formGroup]="formGroup"
        [stageSchema]="stageSchema"
    ></dr-review-stage>
</div>
